import React, { useCallback, useEffect, useState } from 'react';
import * as XLSX from 'xlsx';
import { DrawerComponent } from 'components/Drawer';
import { api } from 'services/api';
import loadingIcon from 'assets/image/loading.svg';
import * as S from './styles';
import CardDrawer from './components/CardDrawer';
import { Mail } from 'styled-icons/feather';
import {
  CheckMarkSignature,
  DocumentSignature,
  DownloadIcon,
  GroupPeople,
} from 'components/Icons';
import moment from 'moment';
import 'moment/locale/pt-br';
import { theme } from 'styles/theme';
import { ToolTip } from 'components/ToolTip';
import { InvoiceStatus } from 'components/InvoiceStatus';
import Hands from 'components/Icons/hands';
interface IConsumptionDetails {
  closeDrawer: () => void;
  idConsumption: string | undefined;
  indicator: any;
  typeProduct: string;
  exceedingEnvelopes: any
}
const ConsumptionDetails = ({
  closeDrawer,
  idConsumption,
  indicator,
  typeProduct,
  exceedingEnvelopes,
}: IConsumptionDetails) => {
  const [isLoading, setIsLoading] = useState(false);
  const accessToken = localStorage.getItem('accessToken');
  const idToken = localStorage.getItem('idToken');
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(1);
  const [isExporting, setIsExporting] = useState(false);
  const [history, setHistory] = useState<any[]>([]);
  const fetchDataDailyQualification = async () => {
    setIsLoading(true);
    const startDate = moment(
      `${indicator.ano}-${indicator.mes}-01`,
      'YYYY-MM-DD',
    ).format('YYYY-MM-DD');
    let endDate;

    const currentMonth = moment().month() + 1; // Mês atual (1 baseado)
    const currentYear = moment().year(); // Ano atual

    // Verifica se o mês indicado é o mesmo do mês atual
    if (indicator.mes === currentMonth && indicator.ano === currentYear) {
      endDate = moment().format('YYYY-MM-DD'); // Usa o dia de hoje
    } else {
      // Caso contrário, usa o último dia do mês indicado
      endDate = moment(`${indicator.ano}-${indicator.mes}-01`)
        .endOf('month')
        .format('YYYY-MM-DD');
    }
    try {
      const { data } = await api.get(
        `qualifier/movto/debit/${idConsumption}?startDate=${startDate}&endDate=${endDate}&page=${currentPage}&limit=${10}&type_product=${typeProduct}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
            idToken,
          },
        },
      );
      setHistory((prevState) => {
        // Filtra os novos dados para garantir que não haja objetos duplicados
        const filteredData = data.data.filter(
          (newItem: any) =>
            !prevState.some(
              (existingItem) =>
                JSON.stringify(existingItem) === JSON.stringify(newItem),
            ),
        );

        // Adiciona os objetos filtrados ao estado
        return [...prevState, ...filteredData];
      });

      setTotalPages(data.pagination.pages);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  const fetchAllDataForExport = async () => {
    const startDate = moment(
      `${indicator.ano}-${indicator.mes}-01`,
      'YYYY-MM-DD',
    ).format('YYYY-MM-DD');
    let endDate;

    const currentMonth = moment().month() + 1; // Mês atual (1 baseado)
    const currentYear = moment().year(); // Ano atual

    // Verifica se o mês indicado é o mesmo do mês atual
    if (indicator.mes === currentMonth && indicator.ano === currentYear) {
      endDate = moment().format('YYYY-MM-DD'); // Usa o dia de hoje
    } else {
      // Caso contrário, usa o último dia do mês indicado
      endDate = moment(`${indicator.ano}-${indicator.mes}-01`)
        .endOf('month')
        .format('YYYY-MM-DD');
    }
    try {
      const { data } = await api.get(
        `qualifier/movto/debit/${idConsumption}/export?startDate=${startDate}&endDate=${endDate}&type_product=${typeProduct}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
            idToken,
          },
        },
      );
      return data.data;
    } catch (error) {
      console.log(error);
      return [];
    }
  };
  const exportToExcel = async () => {
    setIsExporting(true);
    try {
      const allData = await fetchAllDataForExport();

      if (allData.length === 0) {
        alert('Não há dados para exportar');
        return;
      }

      // Preparar os dados para o Excel
      const excelData = allData.map((item: any) => ({
        Data: moment(item.date).format('DD/MM/YYYY HH:mm'),
        'Criado por': item.name_broker || '',
        'Nome do Cliente': item.name_client || '',
        'Nome do documento': item.signature_name || '',
        'Status do documento': item.signature_status || '',
        'Consumo': item.value * -1 || 0,
        'ID da assinatura': item.id_signature || '',
      }));

      // Criar workbook e worksheet
      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet(excelData);

      // Definir largura das colunas
      const columnWidths = [
        { wch: 25 }, // Nome do Cliente
        { wch: 20 }, // Corretor
        { wch: 15 }, // Pretensão
        { wch: 18 }, // Data
        { wch: 25 }, // ID Lead
        { wch: 12 }, // ID Débito
      ];
      worksheet['!cols'] = columnWidths;

      // Adicionar worksheet ao workbook
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Assinaturas');

      // Gerar nome do arquivo
      const monthName =
        moment(`${indicator?.ano}-${indicator?.mes}-01`, 'YYYY-MM-DD')
          .format('MMMM')
          .charAt(0)
          .toUpperCase() +
        moment(`${indicator?.ano}-${indicator?.mes}-01`, 'YYYY-MM-DD')
          .format('MMMM')
          .slice(1);

      const fileName = `Assinaturas_${monthName}_${indicator?.ano}.xlsx`;

      // Fazer download do arquivo
      XLSX.writeFile(workbook, fileName);
    } catch (error) {
      alert('Erro ao exportar dados. Tente novamente.');
    } finally {
      setIsExporting(false);
    }
  };
  useEffect(() => {
    fetchDataDailyQualification();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [indicator, idConsumption, currentPage]);

  const Loader = () => {
    return (
      <S.Loader>
        <img src={loadingIcon} width={36} height={36} />
      </S.Loader>
    );
  };

  const [nextPageDiv, setNextPageDiv] = useState<HTMLDivElement | null>(null);
  const showMoreHistory = () => {
    setCurrentPage((indicatorsPerPage) => indicatorsPerPage + 1);
  };
  const nextPageDivCallback = useCallback((node: HTMLDivElement | null) => {
    setNextPageDiv(node);
  }, []);

  useEffect(() => {
    if (!nextPageDiv) return;

    const observer = new IntersectionObserver(
      (entries) => {
        const target = entries[0];
        if (target.isIntersecting && currentPage < totalPages) {
          showMoreHistory();
        }
      },
      {
        root: null,
        rootMargin: '20px',
        threshold: 0.1,
      },
    );

    observer.observe(nextPageDiv);

    return () => {
      observer.disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nextPageDiv]);
  const pluralize = (count: any, word: any, pluralWord?: any) => {
    return count > 1 ? pluralWord ?? `${word}s` : word;
  };

  const safeCount = (count: any) => count ?? 0;
  const infos = [
    {
      icon: <GroupPeople />,
      title:
        safeCount(indicator?.qtd_total_assinantes) > 0
          ? `${indicator?.qtd_total_assinantes}`
          : 'Nenhuma',
      subTitle: `${pluralize(indicator?.qtd_total_assinantes, 'pessoa')}`,
    },
    {
      icon: <DocumentSignature />,
      title:
        safeCount(indicator?.qtd_total_documentos_assinados) > 0
          ? `${indicator?.qtd_total_documentos_assinados} `
          : 'Nenhum',
      subTitle: `${pluralize(
        indicator?.qtd_total_documentos_assinados,
        'documento',
      )}`,
    },
    {
      icon: <CheckMarkSignature />,
      title:
        safeCount(indicator?.perc_envelopes_assinados) > 0
          ? `${indicator?.perc_envelopes_assinados}%`
          : '0 %',
      subTitle: `de sucesso`,
    },
  ];
  return (
    <DrawerComponent
      open
      size="default"
      // className={styles.drawer}
      onCompleteClose={closeDrawer}
      titleClose={'Consumo mensal'}
    >
      {isLoading && currentPage === 1 ? (
        <Loader />
      ) : (
        <>
          <S.WrapperInvoiceDetail>
            <span>
              {moment(`${indicator?.ano}-${indicator?.mes}-01`, 'YYYY-MM-DD')
                .format('MMMM')
                .charAt(0)
                .toUpperCase() +
                moment(`${indicator?.ano}-${indicator?.mes}-01`, 'YYYY-MM-DD')
                  .format('MMMM')
                  .slice(1)}{' '}
              de{' '}
              {moment(
                `${indicator?.ano}-${indicator?.mes}-01`,
                'YYYY-MM-DD',
              ).format('YYYY')}
            </span>
          </S.WrapperInvoiceDetail>
          <S.ContentDetails>
            <S.Box>
              <S.TextAside fontSize="16" fontWeight="700">
                {indicator?.qtd_total_envelopes} envelopes
              </S.TextAside>
              <S.GridInfos>
                {infos.map((el, index) => (
                  <div
                    key={index}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '16px',
                    }}
                  >
                    {el.icon}
                    <div>
                      <S.TextAside fontSize="16" fontWeight="700">
                        {el.title}
                      </S.TextAside>
                      <S.TextAside fontSize="12" color="#808080">
                        {el.subTitle}
                      </S.TextAside>
                    </div>
                  </div>
                ))}
              </S.GridInfos>
            </S.Box>
            <S.TextAside
              fontSize="16"
              fontWeight="700"
              style={{ marginBottom: '16px' }}
            >
              Saldo recebido
            </S.TextAside>
            <S.Box>
              <div
                style={{
                  display: 'flex',
                  gap: '16px',
                  justifyContent: 'space-between',
                }}
              >
                {' '}
                <S.TextAside fontSize="16" fontWeight="500">
                  Envelopes do plano
                </S.TextAside>{' '}
                <S.TextAside fontSize="16" fontWeight="700">
                <InvoiceStatus
                  status={"venda"}
                  text={indicator?.qtd_creditos_recebidos}
                  icon={<Mail size={16}/>}
                  colortText={
                  theme.colors.neutral.neutral120
                  }
                  fontWeight="500"
                />
                </S.TextAside>
              </div>
              {(indicator.mes === moment().month() + 1 ? exceedingEnvelopes : indicator?.qtd_debitos_negativos) > 0 ?    <> 
               <hr style={{ margin: '16px -24px' }} />
                <div
                  style={{
                    display: 'flex',
                    gap: '16px',
                    justifyContent: 'space-between',
                  }}
                >
                  {' '}
                  <S.TextAside fontSize="16" fontWeight="500">
                    Envelopes pós-pagos
                  </S.TextAside>{' '}
                  <S.TextAside fontSize="16" fontWeight="700">
                  <InvoiceStatus
                    status={"venda"}
                    text={indicator.mes === moment().month() + 1 ? exceedingEnvelopes : indicator?.qtd_debitos_negativos}
                    icon={<Mail size={16}/>}
                    colortText={
                    theme.colors.neutral.neutral120 
                    }
                    fontWeight="500"
                  />
                    
                  </S.TextAside>
                </div>
              </>
              :<></>}
         
            </S.Box>
            <div
              style={{
                display: 'flex',
                gap: '16px',
                justifyContent: 'space-between',
                marginBottom: '16px',
              }}
            >
              <S.TextAside fontSize="16" fontWeight="700">
                Envelopes enviados
              </S.TextAside>
              <span
                onClick={(isExporting || history.length <= 0) ? undefined : exportToExcel}
                style={{
                  color: (isExporting || history.length <= 0)
                    ? theme.colors.neutral.neutral50
                    : theme.colors.primary50,
                  cursor: isExporting || history.length <= 0 ? 'not-allowed' : 'pointer',
                  opacity: isExporting || history.length <= 0 ? 0.6 : 1,
                  pointerEvents: isExporting || history.length <= 0 ? 'none' : 'auto',
                  fontSize: '16px !important',
                }}
              >
                <ToolTip
                  right="2rem"
                  height="3rem"
                  content={
                    isExporting
                      ? 'Download em andamento, aguarde...'
                      : 'Clique para fazer o download dos dados.'
                  }
                  icon={
                    <div style={{ marginLeft: '1rem' }}>
                      {isExporting ? <S.LoadingSpinner /> : <DownloadIcon />}
                    </div>
                  }
                  text={isExporting ? 'Exportando...' : 'Exportar'}
                />
              </span>
            </div>

            <S.Box>
              {history.length > 0 ? (
                history.map((el, index) => (
                  <>
                    <CardDrawer
                      key={el?.id_debit}
                      name={el?.signature_name}
                      status={el?.signature_status}
                      broker={el?.name_broker}
                      date={el?.date}
                      value={el?.value}
                    />

                    {index !== history.length - 1 && (
                      <hr style={{ margin: '16px -24px' }} />
                    )}
                  </>
                ))
              ) : (
                <S.NotLeads>
                  <Hands />
                  <div>
                    <S.TitlePerfomace
                      color={theme.colors.neutral.neutral120}
                      fontWeight={600}
                      fontSize="2rem"
                      style={{ marginBottom: '8px' }}
                    >
                      Nenhum Envelope esse mês
                    </S.TitlePerfomace>
                    <S.SubtitlePerfomace
                      color={theme.colors.neutral.neutral120}
                      fontWeight={500}
                    >
               Crie envelopes com poucos cliques no Imob ou Locação.
                    </S.SubtitlePerfomace>
                  </div>
                </S.NotLeads>
              )}
            </S.Box>
            <div ref={nextPageDivCallback} />
          </S.ContentDetails>
        </>
      )}
    </DrawerComponent>
  );
};
export default ConsumptionDetails;
